import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useEffect, useState } from 'react';

import { getChatsWidgetMicrofrontendV2 } from '../../services/getChatsWidgetMicrofrontend/v2';
import { useApplicationContext } from '../../utils/applicationContext';
import { checkCianMfRegistry } from '../../utils/checkCianMfRegistry';

export const useChatsWidgetMicrofrontend = () => {
  const context = useApplicationContext();
  const [manifest, setManifest] = useState<IMicrofrontendManifest | null>(null);

  useEffect(() => {
    const isCianMfRegistryEnabled = checkCianMfRegistry();

    if (isCianMfRegistryEnabled) {
      getChatsWidgetMicrofrontendV2(context).then(setManifest);
    }
  }, [context]);

  return manifest;
};
